<template>
  <section
    class="hr-section hr-about"
    :class="{ 'hr-about--solo': !showStats }"
    aria-labelledby="hr-about-title"
  >
    <div class="hr-container hr-about__grid">
      <article class="hr-about__card">
        <div class="hr-about__media">
          <video
            v-if="about.video"
            class="hr-about__video"
            :src="about.video"
            :poster="about.image"
            autoplay
            muted
            loop
            playsinline
            aria-label="О перинатальном центре ДАР"
          />
          <img v-else :src="about.image" :alt="about.imageAlt" />
        </div>
        <div class="hr-about__body">
          <h2 id="hr-about-title" class="hr-section-title">{{ about.title }}</h2>
          <p v-for="(p, i) in about.paragraphs" :key="i" class="hr-about__text">{{ p }}</p>
          <router-link class="hr-btn hr-btn--outline" :to="about.moreTo">
            {{ about.moreLabel }}
          </router-link>
        </div>
      </article>

      <ul v-if="showStats" class="hr-stats">
        <li v-for="item in displayStats" :key="item.label" class="hr-stats__item">
          <span class="hr-stats__icon"><HrIcon :name="item.icon" :image="item.iconImage" /></span>
          <strong class="hr-stats__value">{{ item.value }}</strong>
          <span class="hr-stats__label">{{ item.label }}</span>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
import HrIcon from './HrIcon.vue'
import PaidServicesApi from '@/api/paidServices.js'

function formatStatNumber(value) {
  const n = Number(value)
  if (!Number.isFinite(n)) return String(value ?? '—')
  return n.toLocaleString('ru-RU')
}

function formatRating2gis(rating, max) {
  const r = Number(rating)
  const m = Number(max)
  if (!Number.isFinite(r)) return '—'
  const ratingLabel = String(r).replace('.', ',')
  const maxLabel = Number.isFinite(m) && m > 0 ? m : 5
  return `${ratingLabel} из ${maxLabel}`
}

export default {
  name: 'HrAboutStats',
  components: { HrIcon },
  props: {
    about: { type: Object, required: true },
    stats: { type: Array, required: true },
    showStats: { type: Boolean, default: true },
  },
  data() {
    return {
      displayStats: this.stats.map((item) => ({ ...item })),
    }
  },
  mounted() {
    if (this.showStats) {
      this.loadStatistics()
    }
  },
  methods: {
    async loadStatistics() {
      try {
        const response = await PaidServicesApi.getStatistics()
        const result =
          response &&
          response.data &&
          (response.data.result || response.data)

        if (!result || typeof result !== 'object') return

        this.displayStats = this.stats.map((item) => {
          if (item.kind === 'rating2gis') {
            if (result.rating2gis == null) return { ...item }
            return {
              ...item,
              value: formatRating2gis(result.rating2gis, result.rating2gisMax),
            }
          }
          if (!item.field || result[item.field] == null) {
            return { ...item }
          }
          return {
            ...item,
            value: formatStatNumber(result[item.field]),
          }
        })
      } catch (e) {
        console.warn('HrAboutStats: не удалось загрузить статистику', e)
      }
    },
  },
}
</script>
